import { render } from "./BaseErrorContainer.vue?vue&type=template&id=f1c7c284"
import script from "./BaseErrorContainer.vue?vue&type=script&lang=js"
export * from "./BaseErrorContainer.vue?vue&type=script&lang=js"

import "./BaseErrorContainer.vue?vue&type=style&index=0&id=f1c7c284&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__